export const SCORESEND_FORM = 'scoreSendForm'
export const SCORESEND_FIELDNAME = 'selectedSchool'
export const SCORESEND_FIELDDATA = 'school'
export const SCORESEND_DICODE = 'selectedDICode'

export const USER_PROMPT_NONE = 'NONE'
export const ON_PAGE_TOP = 'PAGE_TOP'
export const ON_PAGE_BOTTOM = 'PAGE_BOTTOM'
export const USER_PROMPT_MODAL_INFO = 'MODAL_INFORMATIVE'
export const USER_PROMPT_MODAL_ACTION = 'MODAL_ACTIONABLE'
export const USER_PROMPT_MODAL_UPDATE = 'UPDATE' // diCode is no longer active, prompt student to update

export const NOT_AVAILABLE = 'notAvailable'
export const BEFORE_AVAILABLE = 'beforeAvailable'
export const AFTER_AVAILABLE = 'afterAvailable'
export const AVAILABLE = 'available'

export const STUDENT_ENROLLMENT_STATUS_YES = 'YES'
export const STUDENT_ENROLLMENT_STATUS_NO_OTHER = 'NO_OTHER'

export const SCORE_SEND_FINAL_OPT_OUT_COMPLETE = 2
